import {useContext} from 'react'
import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
// import UpsUiModule from '@thg-harveynash/ups-ui-component'
import UpsUiModule from '@thg-harveynash/mms-ups-ui-component'
import RoutesApp from './routes/Routes'
import {GlobalContext} from './store/GlobalContext'
import './assets/scss/Saas.scss'
import './assets/scss/ups-custom.scss'
import {UpsLayout} from './layouts'
import {ThemeProvider} from 'styled-components'
import {darkTheme, defaultTheme, lightTheme} from './components/theme'
import {LayoutColor} from './constants'

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    detection: {
      order: [
        'localStorage',
        'cookie',
        'htmlTag',
        'sessionStorage',
        'path',
        'subdomain',
      ],
    },
    backend: {
      allowMultiLoading: true,
      loadPath:
        '/locales/{{lng}}/translation.json?v=' + process.env.REACT_APP_VERSION,
    },
    ns: ['translations'],
    defaultNS: 'translations',
  })

const App = () => {
  const {
    state: {
      layout,
      auth,
      permissionInformations: {appCode, permissions},
    },
  } = useContext(GlobalContext)

  const theme =
    layout.layoutColor == LayoutColor.LAYOUT_COLOR_LIGHT
      ? lightTheme
      : darkTheme

  if (auth) {
    if (appCode === 'ups' && permissions && permissions.length) {
      return (
        <ThemeProvider theme={theme}>
          <UpsLayout>
            <UpsUiModule />
          </UpsLayout>
        </ThemeProvider>
      )
    } else {
      return (
        <ThemeProvider theme={theme}>
          <RoutesApp />
        </ThemeProvider>
      )
    }
  }
  return null
}

export default App
